/** Folds the spellings people mix up (hamza forms, taa marbuta, alef maqsura, diacritics, tatweel, case) so either one finds the other. */
export function fold(s: string): string {
  return s.toLowerCase().replace(/[ً-ْـ]/g, "").replace(/[أإآ]/g, "ا").replace(/ة/g, "ه").replace(/ى/g, "ي");
}
